import TYPE from './storeType'

const mutations={
  //用户USERID
  [TYPE.videoToken](state, msg) {
    state.videoToken = msg
  },
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js